import { generateSampleDataset, SAMPLE_DATASET_FILENAME } from "../data/sampleDataset";
import { analyzeData } from "../features/data/analyzer";
import { buildDatasetSchema } from "../features/data/datasetSchema";
import { buildInsights } from "../features/dashboard/insightBuilder";
import { buildDashboard } from "../features/dashboard/dashboardEngine";

// ============================================================
// DEMO SESSION
// ============================================================
//
// Builds a session object shaped exactly like a real, saved InsightPulse
// session (see FileUpload.jsx's runPipeline) — same dataset shape, same
// analyzeData/buildDatasetSchema/buildInsights/buildDashboard pipeline —
// so the demo can be rendered with the app's real ChatWindow/AutoDashboard
// components instead of a separate fake dashboard.
//
// Two things are deliberately different from a real session:
//  - There is no `firebaseId` — the demo session is never written to
//    Firestore, so ChatWindow must be told (via its `isDemo` prop) to skip
//    persistence entirely.
//  - Starter questions are a small static list instead of an AI call
//    (suggestInitialQuestions), so opening the demo never depends on the
//    network/AI provider and never costs an AI call before the visitor has
//    asked to use their one question.

const STARTER_QUESTIONS = [
  "Which product category is most profitable?",
  "Show me revenue by region",
  "What's the revenue trend over time?",
  "Which product is the top performer?",
];

export function buildDemoSession() {
  const dataset = generateSampleDataset();

  const analysis = analyzeData(dataset);
  const schema = buildDatasetSchema(dataset);
  const insights = buildInsights(dataset, schema);
  const dashboard = buildDashboard(dataset, schema);

  return {
    firebaseId: null,
    isDemo: true,
    name: SAMPLE_DATASET_FILENAME,
    dataset,
    analysis,
    schema,
    insights,
    dashboard,
    suggestedQuestions: STARTER_QUESTIONS,
    conversationContext: undefined,
    messages: [
      {
        role: "assistant",
        text: `You're exploring a sample dataset with InsightPulse AI.\n\nI analyzed ${analysis.rows} records across ${analysis.columnCount} columns and I'm ready to answer one question about it — dashboards and insights are already loaded on the right.\n\nWhat would you like to know?`,
      },
    ],
  };
}
